module.exports = __webpack_public_path__ + "img/017-graphic-design-1.d0dba01e.svg";